<template>
  <button
    v-bind="$attrs"
    :class="buttonClasses"
    :disabled="disabled"
    :type="type"
    :style="buttonStyle"
  >
    <slot>
      <IconBase
        v-if="icon && !normalizedImage"
        :icon="icon"
        :tone="currentIconTone"
        size="M"
      />
    </slot>
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import IconBase from "@/elements/UI/icon/IconBase.vue";
import style from "./ButtonUploadImage.module.scss";
import defaultIcon from "$images/icons/button/Name=Image, Size=16, Tone=Default.svg";

export default defineComponent({
  name: "ButtonUploadImage",
  inheritAttrs: false,
  components: {IconBase},
  props: {
    size: {
      type: String as PropType<ButtonImageSizes>,
      default: "28"
    },
    radius: {
      type: String as PropType<"8" | "full">,
      default: "full"
    },
    image: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: defaultIcon
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "tertiary"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  },
  computed: {
    buttonClasses(): string[] {
      return [
        style.buttonUploadImage,
        style[`size${this.size}`],
        this.radius === "8" ? style.radius8 : "",
        this.radius === "full" ? style.radiusFull : "",
        this.normalizedImage ? style.hasImage : "",
        this.active ? style.active : "",
        this.disabled ? style.disabled : ""
      ];
    },
    currentIconTone(): IconTone {
      return this.disabled ? "disabled" : this.iconTone;
    },
    normalizedImage(): string {
      return this.image.trim();
    },
    buttonStyle(): Record<string, string> {
      const image = this.normalizedImage;

      if (!image) {
        return {};
      }

      if (image.startsWith("url(")) {
        return {
          backgroundImage: image
        };
      }

      const escapedImage = image.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

      return {
        backgroundImage: `url("${escapedImage}")`
      };
    }
  }
});
</script>
